import { BubbleRecommendations } from '@xp-utilities/web';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './BubbleRecommendationsWrapper.module.scss';
import useFeatureFlagQuery from './useFeatureFlagQuery';

export default function BubbleRecommendationsWrapper({
  placementIds = [],
  queryId,
  skipQuery = false,
  testId = 'bubbles-recommendations-wrapper',
}) {
  const isFlagEnabled = useFeatureFlagQuery(queryId, skipQuery);

  return (
    placementIds.length > 0 && (isFlagEnabled || skipQuery) ? (
      <section className={styles.bubbleRecommendationsWrapper} data-testid={testId}>
        <BubbleRecommendations
          className={queryId ? styles[queryId] : ''}
          fetchRecommendations
          placements={placementIds}
        />
      </section>
    ) : null
  );
}

BubbleRecommendationsWrapper.propTypes = {
  placementIds: PropTypes.arrayOf(PropTypes.string),
  queryId: PropTypes.string,
  skipQuery: PropTypes.bool,
  testId: PropTypes.string,
};
